{
  "comment": "M10 P1e1: mooring tuning for hulls too big for a station bay (hull tiers spec §6.4). rangeM, the moor request range, is from the station's hull: the centre distance less the station radius (scale build §3.3, SC-5a1a), so the ring stays inside it at every station size. The ring sits max(ringRadiusM, station radius + ringClearM) from the station centre, in the plane of the bay's out axis; its slots spread over the side away from the bay, none within corridorClearDeg of the out axis. enabled gates the player moor flow (P1e2, on): false means an L is refused at bays and can't request moor; true means the dock key asks an L to moor and it flies itself to its ring slot (playerSlot). brakeAccelShare is the share of the hull's weakest linear acceleration the moor approach plans to brake with (speed ≤ √(2 × share × a × d)); 0.5 leaves half to flight assist's lag. defaultBaySize is the size of a DOCK_BAY socket with no size param. Every value is [P].",
  "enabled": true,
  "rangeM": 3000,
  "ringRadiusM": 2000,
  "ringClearM": 300,
  "slots": 8,
  "playerSlot": 0,
  "corridorClearDeg": 60,
  "holdToleranceM": 50,
  "holdSpeedMps": 2,
  "approachSpeedMps": 60,
  "brakeAccelShare": 0.5,
  "launchSpeedMps": 10,
  "aiDwellS": 120,
  "despawnViewHalfAngleDeg": 70,
  "despawnFarM": 12000,
  "defaultBaySize": "M",
  "tender": {
    "comment": "M10 P5a8a: moored market services. While moored at a ring, market buys and sells queue and one Send tender runs them as one batch per visit: tenderS + tenderSPerKt per 1,000 t queued, capped at tenderCapS (s). Leaving the ring cancels unsent lines; a sent run finishes after a launch. Moored repair and refit take serviceTimeMult x the docked time, no extra credit. enabled false keeps today (trades settle at once) until W6 (P5a4c2, review F5). tickS is the run's wall-clock step (the sim holds while docked, so the run steps on a timer). Every value is [P].",
    "enabled": false,
    "tenderS": 20,
    "tenderSPerKt": 10,
    "tenderCapS": 30,
    "serviceTimeMult": 1.5,
    "tickS": 0.25
  },
  "transfers": {
    "comment": "M10 P5a8b: cargo and module transfers between your own ships docked or moored at one station (or the carried pair), free, class-weighted against the target hold. enabled false hides the transfer panel until W6: two owned ships at one station is already possible today, so the gate is data. [P]",
    "enabled": false
  }
}
